import { SwiperFlex, SwiperText, BouncingArrow } from '../styled'
import { Flex, useMatchBreakpointsContext, Text } from '@pancakeswap/uikit'
import { useWeb3React } from '@web3-react/core'
import { HomeConnectButton } from 'views/Home/styled'
import Image from 'next/image'
import baseswap from '../../../../../../public/images/newlogo.png'
import Link from 'next/link'
import { FillerFlex } from './styled'

const SlideOne = ({}) => {
  const { account } = useWeb3React()
  const { isDesktop, isMd } = useMatchBreakpointsContext()

  return (
    <>
      <Flex width="100%" height="100%">
        <FillerFlex />
        <SwiperFlex>
          <Flex width="100%" flexDirection="column">
            <Text fontSize="48px" fontWeight="500" color="teal">
              {' '}
              UNLEASH{' '}
            </Text>
            <Text fontSize="24px" fontWeight="500" textAlign="center" color="text">
              {' '}
              your inner{' '}
            </Text>
            <Text fontSize="48px" fontWeight="500" color="teal" textAlign="end">
              {' '}
              VIKING.{' '}
            </Text>
          </Flex>
          <Flex height={isDesktop ? '100%' : 'auto'} width="100%" flexDirection="column" justifyContent="center">
            <Text fontSize="36px" fontWeight="500" color="teal" textAlign="center">
              TRADE. <span style={{ color: '#fff' }}>STAKE.</span> CONQUER.
            </Text>
          </Flex>

          <Flex width="100%" justifyContent="flex-start" alignItems="center" flexDirection="column">
            {!account ? (
              <>
                <Image src={baseswap} alt="logo" height="77px" width="80px" />
                <HomeConnectButton variant="primary" width="100%" mt="8px" />
              </>
            ) : (
              <Image src={baseswap} alt="logo" height="97px" width="100px" />
            )}
          </Flex>
        </SwiperFlex>

        <FillerFlex />
      </Flex>
    </>
  )
}

export default SlideOne
